import type { ContentItem, ContentId, Mechanic } from '@juegazo/shared';
import { CONTENT_CATALOG } from './content-catalog';

export { CONTENT_CATALOG } from './content-catalog';

export { MECHANIC_INFO, type MechanicInfo } from './mechanic-info';

export const ALL_CONTENT: ContentItem[] = [...CONTENT_CATALOG];

export const CONTENT_BY_ID: Map<ContentId, ContentItem> = new Map(
  ALL_CONTENT.map((c) => [c.id, c]),
);

export const CONTENT_BY_MECHANIC: Map<Mechanic, ContentItem[]> = (() => {
  const map = new Map<Mechanic, ContentItem[]>();
  for (const item of ALL_CONTENT) {
    const list = map.get(item.mechanic) ?? [];
    list.push(item);
    map.set(item.mechanic, list);
  }
  return map;
})();

export const createContentProvider = () => ({
  list: (mechanic: Mechanic): ContentItem[] => CONTENT_BY_MECHANIC.get(mechanic) ?? [],
  byId: (id: ContentId): ContentItem | null => CONTENT_BY_ID.get(id) ?? null,
});
